// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCurrentPageOrderTotal,
    getCurrentPageOrderTotalWithVat,
} from "@insite/client-framework/Store/Data/JobQuotes/JobQuotesSelector";
import translate from "@insite/client-framework/Translate";
import { JobQuoteModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { orderSummaryProps } from "@store/Themes/common/props/order";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    jobQuote?: JobQuoteModel;
    quote?: QuoteModel;
    extendedStyles?: QuoteTotalDisplayStyles;
    overridedStyles?: QuoteTotalDisplayStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    isSalesPerson: state.context.session.isSalesPerson,
    orderTotal: getCurrentPageOrderTotal(state),
    orderTotalWithVat: getCurrentPageOrderTotalWithVat(state),
    showPricing: state.context.showPricing,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface QuoteTotalDisplayStyles {
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyProps;
    itemWrapper?: InjectableCss;
    totalLabel?: TypographyProps;
    totalValue?: TypographyProps;
    realTimeText?: TypographyPresentationProps;
}

export const quoteTotalDisplayStyles: QuoteTotalDisplayStyles = {
    wrapper: orderSummaryProps.wrapper,
    titleWrapper: orderSummaryProps.titleWrapper,
    title: orderSummaryProps.title,
    itemWrapper: orderSummaryProps.itemWrapper,
    totalLabel: orderSummaryProps.itemLabel,
    totalValue: orderSummaryProps.itemValue,
    realTimeText: orderSummaryProps.realTimeText,
};

const QuoteTotalDisplay = ({
    enableVat,
    isSalesPerson,
    jobQuote,
    orderTotal,
    orderTotalWithVat,
    quote,
    showPricing,
    vatPriceDisplay,
    extendedStyles,
    overridedStyles,
}: Props) => {
    const styles = useExpandProps(quoteTotalDisplayStyles, extendedStyles, overridedStyles);

    if (
        ((!quote || !quote.quoteLineCollection) && (!jobQuote || !jobQuote.jobQuoteLineCollection)) ||
        !showPricing ||
        (isSalesPerson && (quote?.isEditable || jobQuote?.isEditable))
    ) {
        return null;
    }

    const title = quote ? translate("Quote Summary") : translate("Job Quote Summary");

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{title}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.totalLabel}>
                    {translate("Total")}
                    {vatPriceDisplay === "DisplayWithVat" || vatPriceDisplay === "DisplayWithAndWithoutVat"
                        ? ` (${translate("Inc. VAT")})`
                        : ` (${translate("Ex. VAT")})`}
                </Typography>
                <Typography {...styles.totalValue}>
                    {quote &&
                        (enableVat && vatPriceDisplay !== "DisplayWithoutVat"
                            ? quote?.orderGrandTotalDisplay
                            : quote?.orderSubTotalDisplay)}
                    {jobQuote && (
                        <LocalizedCurrency
                            amount={
                                enableVat && vatPriceDisplay !== "DisplayWithoutVat" ? orderTotalWithVat : orderTotal
                            }
                        />
                    )}
                </Typography>
            </StyledWrapper>
            {enableVat && vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                <StyledWrapper {...styles.itemWrapper}>
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.totalLabel}>
                            {translate("Total")} ({translate("Ex. VAT")})
                        </Typography>
                        <Typography {...styles.totalValue}>
                            {quote && quote?.orderSubTotalDisplay}
                            {jobQuote && <LocalizedCurrency amount={orderTotal} />}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(QuoteTotalDisplay);
